import React, { useState, useEffect } from 'react';
import { Loader2, XCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const QUICK_REASONS = ['Manque de matière première', 'Manque de temps', 'Matériel indisponible', 'Tâche non nécessaire aujourd\'hui'];

const NotDoneDialog = ({ task, open, onOpenChange, onConfirm, busy }) => {
  const [reason, setReason] = useState('');
  useEffect(() => { if (task) setReason(''); }, [task]);
  if (!task) return null;
  const valid = reason.trim().length > 0;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!busy) onOpenChange(v); }}>
      <DialogContent className="bg-white border-gray-200 max-w-md" data-testid="not-done-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-gray-900">Non réalisée : {task.title}</DialogTitle>
          <DialogDescription className="text-gray-500">Indiquez obligatoirement le motif : le chef en sera informé.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="flex flex-wrap gap-2">
            {QUICK_REASONS.map(r => (
              <button key={r} type="button" onClick={() => setReason(r)} className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${reason === r ? 'bg-red-600 text-white border-red-600' : 'bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100'}`} data-testid="not-done-quick-reason">{r}</button>
            ))}
          </div>
          <div>
            <Label className="text-gray-700">Motif *</Label>
            <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Ex : rupture de stock d'aubergines…" className="mt-1 rounded-xl bg-gray-100 border-gray-200 text-gray-900" data-testid="not-done-reason-input" autoFocus />
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy} className="flex-1 h-12 rounded-full border-gray-300" data-testid="not-done-cancel-btn">Annuler</Button>
          <Button onClick={() => onConfirm({ reason: reason.trim() })} disabled={busy || !valid} className="flex-1 h-12 rounded-full bg-red-600 hover:bg-red-700 text-white font-semibold" data-testid="not-done-confirm-btn">
            {busy ? <Loader2 size={18} className="animate-spin mr-2" /> : <XCircle size={18} className="mr-2" />}Confirmer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotDoneDialog;
